import { type TalentirChain, getChain } from "@talentir/shared/helpers";

export function useTalentirChain(): TalentirChain | undefined {
    const chain = getChain();

    if (chain?.name === "Arbitrum One") {
        return "arbitrum";
    }

    if (chain?.name === "Sepolia") {
        return "sepolia";
    }

    if (chain?.name === "Base") {
        return "base";
    }

    if (chain?.name === "Base Sepolia") {
        return "base-sepolia";
    }
}
